import { Card, Flex, Skeleton, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect, useMemo } from "react";
import { useStores } from "stores";
import { requestWithNotify } from "utils";
import { HintsType } from "interfaces/tooltipSettings";
import { PlateItem, PlateList } from "components";
import { HintsManagementStore } from "stores/HintsManagementStore";
import { getColumns } from "./getColumns";

export const HintsManagement = observer(() => {
  const { hintsManagement } = useStores();
  const { fetchStatus } = hintsManagement;
  const columns = useMemo(() => getColumns(), []);

  const { openNotification } = useNotificationContext();

  useEffect(() => {
    if (fetchStatus !== "fetching" && fetchStatus !== "init") {
      requestWithNotify({
        fetchFn: () => hintsManagement.fetch(),
        openNotification,
      });
    }
  }, []);

  return (
    <Flex vertical>
      <Typography.Title>Управление подсказками</Typography.Title>

      <Card style={{ maxWidth: "1000px" }}>
        {fetchStatus === "fetching" ? (
          <Skeleton active />
        ) : (
          <PlateList<HintsType, HintsManagementStore>
            store={hintsManagement}
            columns={columns}
            PlateComponent={PlateItem}
            showHeader
          />
        )}
      </Card>
    </Flex>
  );
});
